'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LeftOutlined = _interopRequireDefault(require('./lib/icons/LeftOutlined'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _LeftOutlined;
exports.default = _default;
module.exports = _default;